import React, { useState, useEffect, useContext, useReducer } from 'react';
import { Table, Page } from '../../components';
import { GoodsSelect } from '..';
import {
  insertSpecPart,
  updateSpecPart,
  deleteSpecPart,
  getSpecPartList
} from '../../services/Goods';

import {
  Form,
  Row,
  Divider,
  Space,
  Button,
  Modal,
  InputNumber,
  message
} from 'antd';
import {
  ExclamationCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  CloseOutlined,
  CheckOutlined
} from '@ant-design/icons';

import { MasterContext } from '../../App';
import './style';

export default React.forwardRef((props, ref) => {
  const { currentUser, authorities } = useContext(MasterContext);
  const { spec, onCloseCallback } = props;
  const [form] = Form.useForm();
  const [isLoadding, setLoadding] = useState(false);
  const [isShowSpecEdit, setShowSpecEdit] = useState(false);
  const [isShowGoodsSelect, setShowGoodsSelect] = useState(false);
  const [selectedSpecIndex, setSelectedSpecIndex] = useState(undefined);
  const [count, setCount] = useState(1);
  const onGoodsSelect = (goods) => {
    if (goods.length === 0) {
      setShowGoodsSelect(false);
      return;
    }
    try {
      const key = 'update_goods_part';
      console.log('onSave:', goods);
      message.loading({ content: `正在新建配套产品 [...]...`, key });
      const params = goods.map((item, index) => ({ part_goods_spec_id: item.goods_spec_id }));
      //alert(JSON.stringify(params))
      insertSpecPart(spec.goods_id, spec.id, params).then(() => {
        reload();
        setShowGoodsSelect(false);
        message.success({ content: `新建配套产品成功 [...]`, key, duration: 2 });
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const initialState = {
    rows: []
  };
  function reducer(state, action) {
    switch (action.type) {
      case 'list':
        return Object.assign({}, state, { rows: action.data });
      default:
        throw new Error();
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState);
  const { rows } = state;
  const selectedSpec = rows[selectedSpecIndex] || {};

  useEffect(() => {
    setLoadding(true);
    var p1 = new Promise((resolve, reject) => {
      getSpecPartList(spec.goods_id, spec.id).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    Promise.all([p1]).then(values => {
      setLoadding(false);
    });
  }, []);

  const reload = () => {
    var p1 = new Promise((resolve, reject) => {
      getSpecPartList(spec.goods_id, spec.id).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    return Promise.all([p1]).then(values => {
      //setLoadding(false);
    });
  }

  const showDeleteConfirm = (index, item) => {
    Modal.confirm({
      title: '确定删除当前项目吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{item.name}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDeleteSpecPart(item);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onEditSpecPart = async (index) => {
    setSelectedSpecIndex(index);
    setCount(rows[index].count)
    setShowSpecEdit(true);
  }

  const onDeleteSpecPart = async (item) => {
    try {
      const key = 'delete_goods_spec';
      console.log('onDeleteSpec:', item);
      message.loading({ content: '正在删除产品号...', key });
      deleteSpecPart(item.goods_id, item.goods_spec_id, item.part_goods_spec_id).then(() => {
        reload().then(() => {
          message.success({ content: `删除产品号成功 [#${item.name}]`, key, duration: 2 });
        })
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onSaveSpecPart = async () => {
    const values = await form.validateFields();
    try {
      const key = 'create_goods_spec';
      console.log('onNewCallback:', values);
      message.loading({ content: '正在修改产品号...', key });
      updateSpecPart(spec.goods_id, spec.id, selectedSpec.part_goods_spec_id, values).then(() => {
        reload().then(() => {
          setShowSpecEdit(false);
          message.success({ content: `修改产品号成功 [#${values.name}]`, key, duration: 2 });
        })
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const body = () => {
    return (
      <Form form={form} onFinish={onSaveSpecPart} preserve={false}  fields={[{ name: 'count', value: count }]}>
        <Row>
          <Form.Item name="count" label="配置产品数量"  rules={[{ required: true, message: '请输入配置产品数量!' }]}   >
            <InputNumber onChange={setCount} />
          </Form.Item>
        </Row>
        <Divider style={{ margin: '1rem 0' }} />
        <div className="page-footer">
          <Space size="large">
            <Button onClick={onCloseCallback} icon={<CloseOutlined />}>关 闭</Button>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button htmlType="submit" type="primary" icon={<CheckOutlined />}>保 存</Button>
            </div>
          </Space>
        </div>
      </Form>);
  }
  return (
    <div style={{ padding: '1.5rem' }}  >
      <Table
        isLoadding={isLoadding}
        expandable={false}
        title={`配套产品管理`}
        newLabel="新建配套产品"
        showFilter={false}
        showView={false}
        showNewLabel={authorities.find(x => x === 'create_goods') || authorities.find(x => x === 'edit_goods') || currentUser.category_id === 1}
        rows={rows}
        total_rows={rows.length}
        onNew={() => setShowGoodsSelect(true)}
        header={[
          {
            label: '产品名称', item: 'goods_name', width:'230px'
          },
          { label: '产品号', item: 'goods_spec_name' , width:'225px'},
          { label: '配套数量', item: 'count', align: 'right', width:'220px' },
          {
            label: '操作', item: '', align: 'center', width:'180px', render: (text, row, index) => {
              return [
                <Button icon={<EditOutlined />} onClick={() => onEditSpecPart(index)} type="link" size="small" />,
                <Button icon={<DeleteOutlined />} onClick={() => showDeleteConfirm(index, row)} danger type="text" size="small" />
              ]
            }
          }
        ]}
        bordered={true} />
      <div style={{ textAlign: 'right', padding: '1rem 0' }}>
        <Button onClick={onCloseCallback} icon={<CloseOutlined />}>关 闭</Button>
      </div>
      <Page
        title="修改配套产品"
        width="40vw"
        onCloseCallback={() => setShowSpecEdit(!isShowSpecEdit)}
        body={body()}
        visible={isShowSpecEdit}
      />
      <Page
        title="配套产品选择"
        width="1024px"
        onCloseCallback={() => setShowGoodsSelect(!isShowGoodsSelect)}
        body={<GoodsSelect onOk={onGoodsSelect} />}
        visible={isShowGoodsSelect}
      />
    </div>
  )
});
